
import React from 'react';

export default ({ className, ...other }) => (
  <svg className={`icon w12 ${className || ''}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.514 21.114">
    <g id="Grupo_692" data-name="Grupo 692" transform="translate(0.25 0.25)">
      <path id="Trazado_48" data-name="Trazado 48" d="M78.08,0a7.5,7.5,0,0,0-7.507,7.466c0,5.109,6.718,12.609,7,12.926a.679.679,0,0,0,1.006,0c.286-.317,7-7.817,7-12.926A7.5,7.5,0,0,0,78.08,0Zm0,11.222a3.756,3.756,0,1,1,3.777-3.756A3.771,3.771,0,0,1,78.08,11.222Z" transform="translate(-70.573 0)" fill="none" stroke="#fff" strokeWidth="0.5" />
    </g>
  </svg>

);
